
export enum REFEREDUM_VALUE {
    YES = "YES",
    NO = "NO",
}
